import { AbstractControl } from '@angular/forms';
import { DOCUMENT_FORMAT_TYPE } from '../enums/document-format-type.enum';
import { DOCUMENT_STATE_TYPE } from '../enums/document-state-type.enum';

export const DOCUMENT_FORMAT = [
  { id: DOCUMENT_FORMAT_TYPE.PDF, displayValue: 'PDF' },
  { id: DOCUMENT_FORMAT_TYPE.WORD, displayValue: 'Word' },
];

export enum RequestDocumentTypes {
  TECHNICAL_ANNEX = 'TECHNICAL_ANNEX',
  TMG = 'TMG',
}

export const DOC_TYPES = [
  { id: RequestDocumentTypes.TECHNICAL_ANNEX, displayValue: 'Technical Annex to Final Terms' },
  { id: RequestDocumentTypes.TMG, displayValue: 'TMG Form' },
];

export const DOCUMENT_STATE = [
  { id: DOCUMENT_STATE_TYPE.INDICATIVE, displayValue: 'Indicative' },
  { id: DOCUMENT_STATE_TYPE.FINAL, displayValue: 'Final' },
];

export interface DocumentModalResult {
  language: string;
  docFormat: string;
  type?: string;
  documentState: string;
  subtype?: string;
}

export type DocumentModalResultForm = {
  [k in keyof DocumentModalResult]: AbstractControl<DocumentModalResult[k]>;
};
